import {
  createFormState,
  required,
  matchesRegex,
  validateWhen,
} from "redux-freeform";
import { ReduxFreeformField } from "../../types";

// Checks if the value is a decimal with up to 2 decimal places or an integer
const DECIMAL_REGEX = /^\d+(\.\d{1,2})?$/;

export type AgenciesFormConfig = {
  [key: string]: ReduxFreeformField;
};

export const agenciesFormConfig: AgenciesFormConfig = {
  code: {
    defaultValue: "",
    validators: [required()],
  },
  slug: {
    defaultValue: "",
    validators: [required()],
  },
  description: {
    defaultValue: "",
    validators: [required()],
  },
  split_tender: {
    defaultValue: "",
    validators: [required()],
  },
  // This must be camel case because the SearchableSelect specfically checks for this key
  searchTerm: {
    defaultValue: "",
    validators: [],
  },
  /** Receipt Attributes
   * pay_at_message is rendered in the UI as Receipt Footer
   * we intend to rename this column in the database because
   * it is an inherited name from kiosk that doesn't make sense for Cashiering
   */
  pay_at_message: {
    defaultValue: "",
    validators: [],
  },
  header_url: {
    defaultValue: "",
    validators: [],
  },
  /** Agency Fee Config
   * These fields will be used to populate the Agency Fee Config
   * for DC Direct PinPads in Cashiering to interact with DPS.
   */
  split_fee_mid: {
    defaultValue: "",
    validators: [validateWhen(required(), required(), "split_fee_text")],
  },
  split_fee_text: {
    defaultValue: "",
    validators: [validateWhen(required(), required(), "split_fee_mid")],
  },
  convenience_fee: {
    defaultValue: "",
    validators: [
      matchesRegex(DECIMAL_REGEX),
      validateWhen(required(), required(), "max_card_amount_allowed"),
    ],
  },
  max_card_amount_allowed: {
    defaultValue: "",
    validators: [
      matchesRegex(DECIMAL_REGEX),
      validateWhen(required(), required(), "convenience_fee"),
    ],
  },
  service_fee_percentage: {
    defaultValue: "",
    validators: [
      matchesRegex(DECIMAL_REGEX),
      validateWhen(required(), required(), "minimum_service_fee"),
    ],
  },
  minimum_service_fee: {
    defaultValue: "",
    validators: [
      matchesRegex(DECIMAL_REGEX),
      validateWhen(required(), required(), "service_fee_percentage"),
    ],
  },
};

export const {
  reducer: agenciesFormReducer,
  mapStateToProps: agenciesFormMapStateToProps,
  mapDispatchToProps: agenciesFormMapDispatchToProps,
} = createFormState(agenciesFormConfig);
